// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyCPYpVBwVUyA6dfCdSL1lgRNzaeiCsPr8Q",
    authDomain: "jio-leh-c2457.firebaseapp.com",
    projectId: "jio-leh-c2457",
    storageBucket: "jio-leh-c2457.appspot.com",
    messagingSenderId: "534275732022",
    appId: "1:534275732022:web:4570a2a3f26b39aacf5e97"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
